import { Fragment } from 'react';

import { IconRadioChecked } from '@components/icons/radio-checked';
import { IconRadioIdle } from '@components/icons/radio-idle';
import { TextField } from '@components/text-field';
import { useScopedTranslate } from '@locale/translate';

import type { MenuProps } from './types';

import { FilterActionButtons } from '../actions-buttons';
import { FilterListItem } from '../list-item';
import { FilterComparer } from '../shared-types';

const DEFAULT_PARAGRAPH_COMPARERS = [
  'contains',
  'not_contains',
  'is',
  'not_is',
] satisfies Array<FilterComparer>;

export const ParagraphMenu = ({ state, actions, config }: MenuProps) => {
  const { t } = useScopedTranslate();
  const comparers =
    ('allowedComparers' in config && config.allowedComparers) || DEFAULT_PARAGRAPH_COMPARERS;

  return (
    <Fragment>
      {comparers.map((comparer) => {
        const isCurrentComparer = state.comparer === comparer;
        const label = t(`core.comparator.${comparer}`) || comparer;

        return (
          <Fragment key={comparer}>
            <FilterListItem
              icon={isCurrentComparer ? <IconRadioChecked /> : <IconRadioIdle />}
              label={label.replace('...', '')}
              onClick={() => actions.selectComparer(comparer)}
            />
            {isCurrentComparer && (
              <TextField
                autoFocus
                onChange={actions.selectValue}
                value={state.value || ''}
                label={label}
                hideLabel
              />
            )}
          </Fragment>
        );
      })}
      <FilterActionButtons state={state} actions={actions} disableApply={!state.value} />
    </Fragment>
  );
};
